import { IconProps } from "../../utils/global-types/global-types";

const StopCircleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-[12px] h-[12px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M5.985 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.235-5-5-5m2.13 5.615c0 .83-.67 1.5-1.5 1.5h-1.23c-.83 0-1.5-.67-1.5-1.5v-1.23c0-.83.67-1.5 1.5-1.5h1.23c.83 0 1.5.67 1.5 1.5z"
    ></path>
  </svg>
);

export default StopCircleIcon;
